import { DataApiInputParams } from 'src/types/api';
import { Builder, getHeaders, getQueryString } from './utils';

export default (builder: Builder) => {
  return {
    getConfluenceContent: builder.query({
      async queryFn(
        arg: DataApiInputParams,
        { getState },
        extraOptions,
        fetchWithBQ
      ) {
        const url = `providers/confluence_provider?${getQueryString(
          arg.params.params
        )}`;
        return fetchWithBQ({
          url: url,
          ...getHeaders(url)
        });
      }
    })
  };
};
